import React from 'react'
import TextField from '@mui/material/TextField'
import InputAdornment from '@mui/material/InputAdornment'
import Select from '@mui/material/Select'
import MenuItem from '@mui/material/MenuItem'
import Button from '@mui/material/Button'
import Calendar from '../../../components/Calendar/Calendar'
import { SearchIcon } from '../../../components/Icons/Icons'
import { STATUS_TABS } from './helpers'

const FiltersBar = ({
  from,
  to,
  onChangeFrom,
  onChangeTo,
  search,
  onChangeSearch,
  processor,
  onChangeProcessor,
  processorOptions = [],
  paymentType,
  onChangePaymentType,
  statusFilter,
  onChangeStatusFilter,
  onMoreFilters,
  onClear,
}) => {
  return (
    <div
      className="rounded-2xl border border-divider bg-paper p-4 flex flex-wrap items-end gap-3"
      data-testid="filters-bar"
    >
      <div>
        <label className="block text-xs font-medium text-text-secondary mb-1">From</label>
        <Calendar value={from} onChange={onChangeFrom} withLabel={false} />
      </div>
      <div>
        <label className="block text-xs font-medium text-text-secondary mb-1">To</label>
        <Calendar value={to} onChange={onChangeTo} withLabel={false} />
      </div>

      <TextField
        size="small"
        label="Search"
        placeholder="Client or payment ID"
        value={search}
        onChange={(e) => onChangeSearch(e.target.value)}
        data-testid="search-input"
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon />
            </InputAdornment>
          ),
        }}
      />

      <div className="flex flex-col">
        <label className="block text-xs font-medium text-text-secondary mb-1">Processor</label>
        <Select
          size="small"
          value={processor}
          onChange={(e) => onChangeProcessor(e.target.value)}
          data-testid="processor-filter"
          sx={{ minWidth: 150 }}
        >
          <MenuItem value="all">All Processors</MenuItem>
          {processorOptions.map((option) => (
            <MenuItem key={option} value={option}>
              {option}
            </MenuItem>
          ))}
        </Select>
      </div>

      <div className="flex flex-col">
        <label className="block text-xs font-medium text-text-secondary mb-1">Status</label>
        <Select
          size="small"
          value={statusFilter}
          onChange={(e) => onChangeStatusFilter(e.target.value)}
          data-testid="status-filter"
          sx={{ minWidth: 170 }}
        >
          {STATUS_TABS.map(({ key, label }) => (
            <MenuItem key={key} value={key}>
              {label}
            </MenuItem>
          ))}
        </Select>
      </div>

      <div className="flex flex-col">
        <label className="block text-xs font-medium text-text-secondary mb-1">Type</label>
        <Select
          size="small"
          value={paymentType}
          onChange={(e) => onChangePaymentType(e.target.value)}
          data-testid="payment-type-filter"
          sx={{ minWidth: 110 }}
        >
          <MenuItem value="all">All Types</MenuItem>
          <MenuItem value="ACH">ACH</MenuItem>
          <MenuItem value="Card">Card</MenuItem>
        </Select>
      </div>

      <Button size="small" variant="outlined" onClick={onMoreFilters} data-testid="more-filters-btn">
        More Filters
      </Button>
      <Button size="small" variant="text" onClick={onClear} data-testid="clear-filters-btn">
        Clear
      </Button>
    </div>
  )
}

export default FiltersBar
